import { Dtos, SuretyAccountId, SuretyBondId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { bondContractExtractionsQueryKey } from "../bond.keys";

type UseFetchAdminContractExtractionsParams = {
	accountId: SuretyAccountId | null | undefined;
	bondId: SuretyBondId;
	enabled?: boolean;
};

export const useFetchAdminContractExtractions = ({
	accountId,
	bondId,
	enabled = true,
}: UseFetchAdminContractExtractionsParams) => {
	const { get } = useRequest();

	const { data } = useQuery({
		queryKey: bondContractExtractionsQueryKey(bondId),
		queryFn: () => {
			if (accountId == null) throw new Error("accountId is required to fetch contract extractions");
			return get<Dtos.ContractExtraction.Get.Response[]>(
				`/v2/admin/surety/accounts/${accountId}/bonds/${bondId}/contract-extractions`,
			);
		},
		enabled: enabled && accountId != null,
	});

	return { extractions: data };
};
